import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let ApplyTrialService = class ApplyTrialService {
    constructor(applyTrialApi) {
        this.applyTrialApi = applyTrialApi;
        this.getSafeDetail = this.applyTrialApi.getSafeDetail;
        this.putIpLimitation = this.applyTrialApi.putIpLimitation;
        this.putNoticeLimitation = this.applyTrialApi.putNoticeLimitation;
    }
};
ApplyTrialService = __decorate([
    injectable(),
    __param(0, inject(Symbols.ApplyTrialApi)),
    __metadata("design:paramtypes", [Object])
], ApplyTrialService);
export { ApplyTrialService };
